.description {
  margin-bottom: 20px;
}

.water-mark-setting {
  margin-top: 20px;
}
